import { render } from "./MessagesConversations.vue?vue&type=template&id=7ac23c51&scoped=true&ts=true"
import script from "./MessagesConversations.vue?vue&type=script&lang=ts"
export * from "./MessagesConversations.vue?vue&type=script&lang=ts"

import "./MessagesConversations.vue?vue&type=style&index=0&id=7ac23c51&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac23c51"]])

export default __exports__